import differenceInHours from "date-fns/differenceInHours";
import differenceInMinutes from "date-fns/differenceInMinutes";
import differenceInSeconds from "date-fns/differenceInSeconds";
export var countdownString = function(deadlineDate, currentDate) {
    return "".concat(differenceInHours(deadlineDate, currentDate), ":").concat(toTwoDigits(differenceInMinutes(deadlineDate, currentDate) % 60), ":").concat(toTwoDigits(differenceInSeconds(deadlineDate, currentDate) % 60));
};
export var toTwoDigits = function(value) {
    return String(value).slice(-2).padStart(2, "0");
};
